import {AbstractControl, ValidationErrors, ValidatorFn} from '@angular/forms';

export class FormValidators {
    static minDate(min: Date): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (control.value) {
                const date = new Date(control.value);
                return FormValidators.validateMinDate(min, date) ? {'minDate': true} : null;
            }
            return null;
        };
    }

    static maxDate(max: Date): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (control.value) {
                const date = new Date(control.value);
                return FormValidators.validateMaxDate(max, date) ? {'maxDate': true} : null;
            }
            return null;
        };
    }

    static dateRange(min: Date, max: Date, startDateCtrl: AbstractControl = null, endDateCtrl: AbstractControl = null): ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {
            if (control.value) {
                const date = new Date(control.value);
                let hasErrors = (FormValidators.validateMinDate(min, date) || FormValidators.validateMaxDate(max, date));
                if (!hasErrors) {
                    if (startDateCtrl) {
                        const startDate = new Date(startDateCtrl.value);
                        hasErrors = FormValidators.validateMinDate(startDate, date);
                    }
                    if (!hasErrors && endDateCtrl) {
                        const endDate = new Date(endDateCtrl.value);
                        hasErrors = FormValidators.validateMaxDate(endDate, date);
                    }
                }
                return hasErrors ? {'dateRange': true} : null;
            }
            return null;
        };
    }

    private static validateMinDate(min: Date, date: Date): boolean {
        return min ? (date < min) : false;
    }

    private static validateMaxDate(max: Date, date: Date): boolean {
        return max ? (date > max) : false;
    }
}
